import { FC } from 'react';
import {
  NavWrapper,
  NavButtonLeft,
  NavButtonRight,
  NavCounter,
  MobileNavButton,
  MobileNavCounterText,
  ShrinkButton,
  MobileShrinkIconWrap,
  SidebarButton,
  RightControlsWrapper,
} from '../styles/PresentationModeModal.styles';
import { PresentationMobileShrinkIcon, ShrinkPresentationIcon, PresentationSidebarIcon, PresentationLeftArrowIcon, PresentationRightArrowIcon } from '../../../icons';

interface NavigationProps {
  totalSlides: number;
  currentSlide: number;
  canGoPrev: boolean;
  canGoNext: boolean;
  isMobile?: boolean;
  onPrev: () => void;
  onNext: () => void;
  onShrink: () => void;
  onToggleSidebar: () => void;
}

const MobilePrevArrowIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M5.84199 8L11.7765 13.7402C12.0745 14.0284 12.0745 14.4957 11.7765 14.7839C11.4786 15.0721 10.9955 15.072 10.6975 14.7838L4.22347 8.52183C3.92551 8.23363 3.92551 7.76637 4.22347 7.47817L10.6975 1.21615C10.9955 0.927951 11.4786 0.927949 11.7765 1.21615C12.0745 1.50435 12.0745 1.97161 11.7765 2.25981L5.84199 8Z" fill="white" />
  </svg>
);

const MobileNextArrowIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z" fill="white" />
  </svg>
);

export const Navigation: FC<NavigationProps> = ({
  totalSlides,
  currentSlide,
  canGoPrev,
  canGoNext,
  isMobile,
  onPrev,
  onNext,
  onShrink,
  onToggleSidebar,
}) => {
  return (
    <>
      <SidebarButton onClick={onToggleSidebar}>
        <PresentationSidebarIcon />
      </SidebarButton>

      <RightControlsWrapper>
        {totalSlides > 1 && (
          <NavWrapper>
            <NavButtonLeft onClick={onPrev} disabled={!canGoPrev}>
              <PresentationLeftArrowIcon />
            </NavButtonLeft>
            <NavCounter>
              {isMobile && (
                <MobileNavButton type="button" onClick={onPrev} disabled={!canGoPrev} aria-label="Previous slide">
                  <MobilePrevArrowIcon />
                </MobileNavButton>
              )}
              <MobileNavCounterText>
                {currentSlide + 1} / {totalSlides}
              </MobileNavCounterText>
              {isMobile && (
                <MobileNavButton type="button" onClick={onNext} disabled={!canGoNext} aria-label="Next slide">
                  <MobileNextArrowIcon />
                </MobileNavButton>
              )}
            </NavCounter>
            <NavButtonRight onClick={onNext} disabled={!canGoNext}>
              <PresentationRightArrowIcon />
            </NavButtonRight>
          </NavWrapper>
        )}
        <ShrinkButton onClick={onShrink}>
          {!isMobile ? <ShrinkPresentationIcon /> : (<MobileShrinkIconWrap>
            <PresentationMobileShrinkIcon />
          </MobileShrinkIconWrap>)}
        </ShrinkButton>
      </RightControlsWrapper>
    </>
  );
};
import { FC } from 'react';
import {
  NavWrapper,
  NavButtonLeft,
  NavButtonRight,
  NavCounter,
  MobileNavButton,
  MobileNavCounterText,
  ShrinkButton,
  MobileShrinkIconWrap,
  SidebarButton,
  RightControlsWrapper,
} from '../styles/PresentationModeModal.styles';
import { PresentationMobileShrinkIcon, ShrinkPresentationIcon, PresentationSidebarIcon, PresentationLeftArrowIcon, PresentationRightArrowIcon } from '../../../icons';

interface NavigationProps {
  totalSlides: number;
  currentSlide: number;
  canGoPrev: boolean;
  canGoNext: boolean;
  isMobile?: boolean;
  onPrev: () => void;
  onNext: () => void;
  onShrink: () => void;
  onToggleSidebar: () => void;
}

const MobilePrevArrowIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M5.84199 8L11.7765 13.7402C12.0745 14.0284 12.0745 14.4957 11.7765 14.7839C11.4786 15.0721 10.9955 15.072 10.6975 14.7838L4.22347 8.52183C3.92551 8.23363 3.92551 7.76637 4.22347 7.47817L10.6975 1.21615C10.9955 0.927951 11.4786 0.927949 11.7765 1.21615C12.0745 1.50435 12.0745 1.97161 11.7765 2.25981L5.84199 8Z" fill="white" />
  </svg>
);

const MobileNextArrowIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z" fill="white" />
  </svg>
);

export const Navigation: FC<NavigationProps> = ({
  totalSlides,
  currentSlide,
  canGoPrev,
  canGoNext,
  isMobile,
  onPrev,
  onNext,
  onShrink,
  onToggleSidebar,
}) => {
  return (
    <>
      <SidebarButton onClick={onToggleSidebar}>
        <PresentationSidebarIcon />
      </SidebarButton>

      <RightControlsWrapper>
        {totalSlides > 1 && (
          <NavWrapper>
            <NavButtonLeft onClick={onPrev} disabled={!canGoPrev}>
              <PresentationLeftArrowIcon />
            </NavButtonLeft>
            <NavCounter>
              {isMobile && (
                <MobileNavButton type="button" onClick={onPrev} disabled={!canGoPrev} aria-label="Previous slide">
                  <MobilePrevArrowIcon />
                </MobileNavButton>
              )}
              <MobileNavCounterText>
                {currentSlide + 1} / {totalSlides}
              </MobileNavCounterText>
              {isMobile && (
                <MobileNavButton type="button" onClick={onNext} disabled={!canGoNext} aria-label="Next slide">
                  <MobileNextArrowIcon />
                </MobileNavButton>
              )}
            </NavCounter>
            <NavButtonRight onClick={onNext} disabled={!canGoNext}>
              <PresentationRightArrowIcon />
            </NavButtonRight>
          </NavWrapper>
        )}
        <ShrinkButton onClick={onShrink}>
          {!isMobile ? <ShrinkPresentationIcon /> : (<MobileShrinkIconWrap>
            <PresentationMobileShrinkIcon />
          </MobileShrinkIconWrap>)}
        </ShrinkButton>
      </RightControlsWrapper>
    </>
  );
};
